import { Component } from '@angular/core';
import { HeaderComponent } from '../../components/header/header.component';
@Component({
  selector: 'app-indexPage',
  standalone: true,
  imports: [ HeaderComponent],
  templateUrl: './policies.component.html',
})
export class PoliciesComponentPage {
 constructor() {
    document.body.style.backgroundColor = '#fff';
  }
  
}
